/* global session */
export default [{
  path: '*',
  meta: {
    public: true,
    roles: ['*']
  },
  redirect: {
    path: '/404'
  }
}, {
  path: '/404',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'NotFound',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/NotFound.vue`
        )
}, {
  path: '/403',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'AccessDenied',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Deny.vue`
        )
}, {
  path: '/500',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'ServerError',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Error.vue`
        )
}, {
  path: '/login',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'Login',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Login.vue`
        )
},
{
  path: '/join/:agencyId?',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'Join',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Join.vue`
        )
},
{
  path: '/forgotPassword',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'ForgotPassword',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ResetPassword/ForgotPassword.vue`
        )
},
{
  path: '/forgotUsername',
  meta: {
    public: true,
    roles: ['*']
  },
  name: 'ForgotUsername',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ResetPassword/ForgotUsername.vue`
        )
},
{
  path: '/logout',
  meta: {
    public: true,
    navLink: 'Logout',
    roles: ['*']
  },
  name: 'Logout',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Logout.vue`
        )
}, {
  path: '/',
  meta: {
    title: 'Home',
    navLink: 'Dashboard',
    roles: ['*']
  },
  name: 'Root',
  redirect: {
    name: 'Dashboard'
  }
}, {
  path: '/dashboard',
  meta: {
    breadcrumb: false,
    title: 'Home',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'Dashboard',
  component: () =>
        import(`@/pages/Dashboard.vue`)
},
{
  path: '/education',
  meta: {
    breadcrumb: false,
    title: 'Education',
    navLink: 'Education',
    roles: ['parent']
  },
  name: 'Education',
  component: () =>
        import(`@/pages/Education.vue`)
},
{
  path: '/child/dashboard',
  meta: {
    breadcrumb: false,
    title: 'Home',
    navLink: 'ChildDashboard',
    roles: ['child']
  },
  name: 'ChildDashboard',
  component: () =>
        import(`@/pages/ChildDashboard.vue`)
},
{
  path: '/admin/dashboard',
  meta: {
    breadcrumb: false,
    title: 'Dashboard',
    navLink: 'AdminDashboard',
    roles: ['admin']
  },
  name: 'AdminDashboard',
  component: () =>
        import(`@/pages/AdminDashboard.vue`)
}, {
  path: '/help',
  meta: {
    breadcrumb: false,
    title: 'Your Help',
    roles: ['*']
  },
  name: 'Help',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Help/Help.vue`
        )
}, {
  path: '/aboutUs',
  meta: {
    breadcrumb: false,
    title: 'Parent Info',
    navLink: 'AboutUs',
    roles: ['parent']
  },
  name: 'AboutUs',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AboutUs.vue`
        )
},
{
  path: '/child/about',
  meta: {
    breadcrumb: false,
    title: 'About',
    navLink: 'ChildInfo',
    roles: ['child']
  },
  name: 'ChildInfo',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ChildInfo.vue`
        )
},
{
  path: '/childPreferences',
  meta: {
    breadcrumb: false,
    title: 'Child Preferences',
    navLink: 'ChildPreferences',
    roles: ['parent']
  },
  name: 'ChildPreferences',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ChildPreferences.vue`
        )
},
{
  path: '/profileDocs',
  meta: {
    breadcrumb: false,
    title: 'Profile Layout',
    navLink: 'ProfileDocuments',
    roles: ['parent']
  },
  name: 'ProfileDocuments',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ProfileDocuments/parent.vue`
        )
},
{
  path: '/request/profileDocs',
  meta: {
    breadcrumb: false,
    title: 'Profile Layouts',
    navLink: 'ProfileDocumentsList',
    roles: ['admin']
  },
  name: 'ProfileDocumentsList',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ProfileDocuments/admin_list.vue`
        )
},
{
  path: '/request/agency/profileDocs',
  meta: {
    breadcrumb: false,
    title: 'Profile Layouts',
    navLink: 'ProfileDocumentsAgencyList',
    roles: ['agency', 'caseworker']
  },
  name: 'ProfileDocumentsAgencyList',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ProfileDocuments/agency_list.vue`
        )
},
{
  path: '/request/profileDocs/:id',
  meta: {
    breadcrumb: false,
    title: 'Profile Layout',
    navLink: 'ProfileDocumentsList',
    roles: ['admin']
  },
  name: 'ProfileDocumentsReview',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ProfileDocuments/admin_view.vue`
        )
},
{
  path: '/request/agency/profileDocs/:id',
  meta: {
    breadcrumb: false,
    title: 'Profile Layout',
    navLink: 'ProfileDocumentsAgencyList',
    roles: ['agency', 'caseworker']
  },
  name: 'ProfileDocumentsAgencyDetails',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ProfileDocuments/agency_view.vue`
        )
},
{
  path: '/albums',
  meta: {
    breadcrumb: false,
    title: 'Albums',
    navLink: 'Albums',
    roles: ['parent', 'child']
  },
  name: 'Albums',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Albums.vue`
        )
}, {
  path: '/photos/:id',
  meta: {
    breadcrumb: false,
    title: 'Photos',
    navLink: 'Albums',
    roles: ['parent', 'child']
  },
  name: 'Photos',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Photos.vue`
        )
}, {
  path: '/projects/:id',
  meta: {
    breadcrumb: false,
    title: 'Projects',
    navLink: 'Videos',
    roles: ['parent']
  },
  name: 'Project',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/VideoProject/Sections.vue`
        )
}, {
  path: '/sections/:id',
  meta: {
    breadcrumb: false,
    title: 'Sections',
    navLink: 'Videos',
    roles: ['parent']
  },
  name: 'Sections',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/VideoProject/Items.vue`
        )
}, {
  path: '/videos',
  meta: {
    breadcrumb: false,
    title: 'Videos',
    navLink: 'Videos',
    roles: ['parent', 'agency', 'child', 'caseworker']
  },
  name: 'Videos',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Videos.vue`
        )
}, {
  path: '/video/create',
  meta: {
    breadcrumb: false,
    title: 'Video Create',
    navLink: 'Videos',
    roles: ['parent', 'agency', 'caseworker']
  },
  name: 'VideosCreation',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Video/create.vue`
        )
}, {
  path: '/admin/accountSettings',
  meta: {
    breadcrumb: false,
    title: 'Account Settings',
    navLink: 'AccountSettings',
    roles: ['admin']
  },
  name: 'AccountSettings',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AccountSettings.vue`
        )
}, {
  path: '/admin/badgeContacts',
  meta: {
    breadcrumb: false,
    title: 'Badge Contacts',
    navLink: 'AdminBadgeContacts',
    roles: ['admin']
  },
  name: 'AdminBadgeContacts',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/BadgeContacts/adminList.vue`
        )
}, {
  path: '/badgeContacts',
  meta: {
    breadcrumb: false,
    title: 'Badge Contacts',
    navLink: 'AgencyBadgeContacts',
    roles: ['agency', 'caseworker']
  },
  name: 'AgencyBadgeContacts',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/BadgeContacts/agencyList.vue`
        )
}, {
  path: '/admin/videoProject',
  meta: {
    breadcrumb: false,
    title: 'Video Project',
    navLink: 'VideoProject',
    roles: ['admin']
  },
  name: 'VideoProject',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/VideoProject/projectList.vue`
        )
}, {
  path: '/admin/account/:account',
  meta: {
    breadcrumb: false,
    title: 'Account Information',
    navLink: 'AccountInformation',
    roles: ['admin']
  },
  name: 'AccountInformation',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AccountInformation.vue`
        )

}, {
  path: '/admin/notes',
  meta: {
    breadcrumb: false,
    title: 'Notes',
    navLink: 'NotesList',
    roles: ['admin', 'parent']
  },
  name: 'NotesList',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Notes/list.vue`
        )

}, {
  path: '/admin/addNotes',
  meta: {
    breadcrumb: false,
    title: 'Add Note',
    navLink: 'AddNotes',
    roles: ['admin', 'parent']
  },
  name: 'AddNotes',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Notes/add.vue`
        )

}, {
  path: '/admin/projects/:id',
  meta: {
    breadcrumb: false,
    title: 'Projects',
    navLink: 'VideoProject',
    roles: ['admin']
  },
  name: 'adminProject',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/VideoProject/adminSection.vue`
        )
}, {
  path: '/admin/sections/:id',
  meta: {
    breadcrumb: false,
    title: 'Sections',
    navLink: 'VideoProject',
    roles: ['admin']
  },
  name: 'adminSections',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/VideoProject/adminItem.vue`
        )
}, {
  path: '/admin/helpVideos',
  meta: {
    breadcrumb: false,
    title: 'Help Videos',
    navLink: 'AdminHelpVideos',
    roles: ['admin']
  },
  name: 'AdminHelpVideos',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/HelpVideos/AdminList.vue`
        )
}, {
  path: '/helpVideos',
  meta: {
    breadcrumb: false,
    title: 'Help Videos',
    navLink: 'Dashboard',
    roles: ['parent', 'child']
  },
  name: 'HelpVideos',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/HelpVideos/list.vue`
        )
}, {
  path: '/contactInformation',
  meta: {
    breadcrumb: false,
    title: 'Contact Information',
    navLink: 'ContactInformation',
    roles: ['parent', 'child']
  },
  name: 'ContactInformation',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ContactInformation.vue`
        )
},
{
  path: '/request/addMoreData',
  meta: {
    breadcrumb: false,
    title: 'Request / Add More Data',
    navLink: 'AddMoreData',
    roles: ['parent']
  },
  name: 'AddMoreData',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/RequestAddMoreData.vue`
        )
},
{
  path: '/letters',
  meta: {
    breadcrumb: false,
    title: 'Letters',
    navLink: 'Letters',
    roles: ['parent', 'child']
  },
  name: 'Letters',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Letters/list.vue`
        )
}, {
  path: '/agencies',
  meta: {
    breadcrumb: false,
    title: 'My Agencies',
    navLink: 'MyAgencies',
    roles: ['parent']
  },
  name: 'MyAgencies',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/MyAgencies.vue`
        )
},
{
  path: '/bmcampaign',
  meta: {
    breadcrumb: false,
    title: 'Campaign',
    navLink: 'BMCampaign',
    roles: ['parent']
  },
  name: 'BMCampaign',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Campaign/main.vue`
        )
},
{
  path: '/blog',
  meta: {
    breadcrumb: false,
    title: 'Blog',
    navLink: 'Blog',
    roles: ['parent', 'child']
  },
  name: 'Blog',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Blog/list.vue`
        )
}, {
  path: '/socialMedia',
  meta: {
    breadcrumb: false,
    title: 'Social Media',
    navLink: 'SocialMedia',
    roles: ['parent']
  },
  name: 'SocialMedia',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/SocialMedia.vue`
        )
},
{
  path: '/membership',
  meta: {
    breadcrumb: false,
    title: 'Membership',
    navLink: 'Membership',
    roles: ['parent']
  },
  name: 'Membership',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Membership.vue`
        )
},
{
  path: '/password',
  meta: {
    breadcrumb: false,
    title: 'Change Password',
    navLink: 'ChangePassword',
    roles: ['parent', 'agency', 'caseworker']
  },
  name: 'ChangePassword',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ChangePassword.vue`
        )
}, {
  path: '/resetPassword',
  meta: {
    breadcrumb: false,
    title: 'Reset Password',
    navLink: 'ResetPassword',
    roles: ['admin']
  },
  name: 'ResetPassword',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ResetPassword/ResetPassword.vue`
        )
},
{
  path: '/changeUsername',
  meta: {
    breadcrumb: false,
    title: 'Change Username',
    navLink: 'ChangeUsername',
    roles: ['admin', 'parent']
  },
  name: 'ChangeUsername',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ResetPassword/changeUsername.vue`
        )
},
{
  path: '/blog/add',
  meta: {
    breadcrumb: false,
    title: 'Blog',
    navLink: 'Blog',
    roles: ['parent', 'child']
  },
  name: 'AddBlog',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Blog/add.vue`
        )
}, {
  path: '/templates/:templateId',
  meta: {
    breadcrumb: false,
    title: 'Themes',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'TemplateDetail',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Template/view.vue`
        )
}, {
  path: '/letter/add',
  meta: {
    breadcrumb: false,
    title: 'Letters',
    navLink: 'Letters',
    roles: ['parent', 'child']
  },
  name: 'LetterAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Letters/add.vue`
        )
}, {
  path: '/templates',
  meta: {
    breadcrumb: false,
    title: 'Themes',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'TemplateSelection',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Template/listFamily.vue`
        )
},
{
  path: '/families',
  meta: {
    breadcrumb: false,
    title: 'Manage Families',
    navLink: 'FamilyManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'FamilyManagement',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/FamilyManagement.vue`
        )
},
{
  path: '/children',
  meta: {
    breadcrumb: false,
    title: 'Manage Children',
    navLink: 'ChildManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ChildManagement',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Children/list.vue`
        )
},
{
  path: '/children/add',
  meta: {
    breadcrumb: false,
    title: 'Children',
    navLink: 'ChildManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ChildAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Children/child.vue`
        )
},
{
  path: '/children/existing',
  meta: {
    breadcrumb: false,
    title: 'Children',
    navLink: 'ChildManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ChildAddExisting',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Children/selectExistingChildren.vue`
        )
},
{
  path: '/children/:id',
  meta: {
    breadcrumb: false,
    title: 'Children',
    navLink: 'ChildManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ChildView',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Children/child.vue`
        )
},
{
  path: '/displayLocations',
  meta: {
    breadcrumb: false,
    title: 'Children',
    navLink: 'ChildManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ChildDisplayLocations',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Children/displayLocations.vue`
        )
},
{
  path: '/childInquires',
  meta: {
    breadcrumb: false,
    title: 'Children',
    navLink: 'ChildManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ChildInquires',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Children/Inquiries.vue`
        )
},
{
  path: '/settings/profileDocs',
  meta: {
    breadcrumb: false,
    title: 'Profile Layout',
    navLink: 'ProfileLayoutSettings',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ProfileLayoutSettings',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ProfileDocuments/setup.vue`
        )
},
{
  path: '/badge/family/setup',
  meta: {
    breadcrumb: false,
    title: 'Family Badge Management',
    navLink: 'FamilyBadgeManagement',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'FamilyBadgeManagement',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Badge/setup.vue`
        )
},
{
  path: '/settings/domains',
  meta: {
    breadcrumb: false,
    title: 'Client Domains',
    navLink: 'ClientDomainsConfig',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'ClientDomainsConfig',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ClientDomains/config.vue`
        )
},
// {
//   path: '/badge/child/setup',
//   meta: {
//     breadcrumb: false,
//     title: 'Child Badge Management',
//     navLink: 'ChildBadgeManagement',
//     roles: ['admin', 'agency', 'caseworker']
//   },
//   name: 'ChildBadgeManagement',
//   component: () =>
//         import(
//           /* webpackChunkName: "routes" */
//           /* webpackMode: "lazy-once" */
//           `@/pages/Badge/child_setup.vue`
//         )
// },
// {
//   path: '/files',
//   meta: {
//     breadcrumb: false,
//     title: 'Files',
//     navLink: 'Dashboard',
//     roles: ['parent']
//   },
//   name: 'Files',
//   component: () =>
//         import(
//           /* webpackChunkName: "routes" */
//           /* webpackMode: "lazy-once" */
//           `@/pages/ParentFiles.vue`
//         )
// }, {
//   path: '/fileAdd',
//   meta: {
//     breadcrumb: false,
//     title: 'Files',
//     navLink: 'Dashboard',
//     roles: ['parent']
//   },
//   name: 'File Add',
//   component: () =>
//         import(
//           /* webpackChunkName: "routes" */
//           /* webpackMode: "lazy-once" */
//           `@/pages/ParentFilesAdd.vue`
//         )
// },
{
  path: '/files',
  meta: {
    breadcrumb: false,
    title: 'Files',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'Files',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Files/ParentFiles.vue`
        )
}, {
  path: '/admin/helpFiles',
  meta: {
    breadcrumb: false,
    title: 'Admin Files',
    navLink: 'AdminFiles',
    roles: ['admin']
  },
  name: 'AdminFiles',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Files/AdminFiles.vue`
        )
}, {
  path: '/admin/fileAdd',
  meta: {
    breadcrumb: false,
    title: 'Help Files',
    navLink: 'AdminFiles',
    roles: ['admin']
  },
  name: 'Help File Add',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Files/AdminFilesAdd.vue`
        )
}, {
  path: '/fileAdd',
  meta: {
    breadcrumb: false,
    title: 'Files',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'File Add',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Files/ParentFilesAdd.vue`
        )
}, 
{
  path: '/agency/dashboard',
  meta: {
    breadcrumb: false,
    title: 'Organization Dashboard',
    navLink: 'AgencyDashboard',
    roles: ['agency', 'caseworker']
  },
  name: 'AgencyDashboard',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AgencyDashboard.vue`
        )
},
{
  path: '/youtube',
  meta: {
    breadcrumb: false,
    title: 'Youtube',
    navLink: 'Youtube',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'Youtube',
  component: () =>
        import(
          `@/pages/Youtube.vue`
        )
},
{
  path: '/googleAds',
  meta: {
    breadcrumb: false,
    title: 'GoogleAds',
    navLink: 'GoogleAds',
    roles: ['admin']
  },
  name: 'GoogleAds',
  component: () =>
        import(
          `@/pages/GoogleAds.vue`
        )
}, {
  path: '/agencies/add',
  meta: {
    breadcrumb: false,
    title: 'Find Agency',
    navLink: 'MyAgencies',
    roles: ['parent']
  },
  name: 'AddAgency',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AgencyAdd.vue`
        )
}, {
  path: '/email',
  meta: {
    breadcrumb: false,
    title: 'Email Addresses',
    navLink: 'Configuration',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'Email Addresses',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Email.vue`
        )
}, {
  path: '/taskDetails/settings',
  meta: {
    breadcrumb: false,
    title: 'Task Details',
    navLink: 'TaskDetailsSettings',
    roles: ['admin']
  },
  name: 'TaskDetailsSettings',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/taskDetailsSettings.vue`
        )
},
{
  path: '/settings/menu',
  meta: {
    breadcrumb: false,
    title: 'Settings',
    navLink: 'FamilyMenu',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'FamilyMenu',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Settings/menu.vue`
        )
},
{
  path: '/settings/blacklist',
  meta: {
    breadcrumb: false,
    title: 'Settings',
    navLink: 'Blacklist',
    roles: ['admin']
  },
  name: 'Blacklist',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Settings/blacklist.vue`
        )
},
{
  path: '/settings/signup',
  meta: {
    breadcrumb: false,
    title: 'Signup',
    navLink: 'SignupForm',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'SignupForm',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Settings/signup.vue`
        )
},
{
  path: '/settings/familyContent',
  meta: {
    breadcrumb: false,
    title: 'Settings',
    navLink: 'FamilyContent',
    roles: ['agency', 'caseworker']
  },
  name: 'FamilyContent',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Settings/familyContent.vue`
        )
},
{
  path: '/settings/blogs',
  meta: {
    breadcrumb: false,
    title: 'Settings',
    navLink: 'BlogSettings',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'BlogSettings',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Settings/blogs.vue`
        )
},
{
  path: '/settings/api',
  meta: {
    breadcrumb: false,
    title: 'REST API',
    navLink: 'APISettings',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'APISettings',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Settings/api.vue`
        )
},
{
  path: '/phone',
  meta: {
    breadcrumb: false,
    title: 'Phone Numbers',
    navLink: 'Configuration',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'Phone Numbers',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Phone.vue`
        )
}, {
  path: '/admin/templates',
  meta: {
    breadcrumb: false,
    title: 'Templates',
    navLink: 'Templates',
    roles: ['admin']
  },
  name: 'Templates',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Template/list.vue`
        )
}, {
  path: '/admin/templates/add',
  meta: {
    breadcrumb: false,
    title: 'Templates',
    navLink: 'Templates',
    roles: ['admin']
  },
  name: 'AddTemplate',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Template/add.vue`
        )
}, {
  path: '/imageDownload',
  meta: {
    breadcrumb: false,
    title: 'Downloads',
    navLink: 'Albums',
    roles: ['parent']
  },
  name: 'ImageDownload',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ImageDownload.vue`
        )
}, {
  path: '/configuration',
  meta: {
    breadcrumb: false,
    title: 'Configuration',
    navLink: 'Configuration',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'Configuration',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Configuration.vue`
        )
}, {
  path: '/memberships',
  meta: {
    breadcrumb: false,
    title: 'Memberships',
    navLink: 'Memberships',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'Memberships',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Memberships.vue`
        )
},
{
  path: '/FileCategories',
  meta: {
    breadcrumb: false,
    title: 'File Categories',
    navLink: 'FileCategories',
    roles: ['admin']
  },
  name: 'FileCategories',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/FileCategories.vue`
        )
}, {
  path: '/AppVersion',
  meta: {
    breadcrumb: false,
    title: 'App Versions',
    navLink: 'appVersions',
    roles: ['admin']
  },
  name: 'appVersions',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AppVersion/list.vue`
        )
}, {
  path: '/AppVersionAdd',
  meta: {
    breadcrumb: false,
    title: 'App Versions',
    navLink: 'appVersions',
    roles: ['admin']
  },
  name: 'appVersionsAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/AppVersion/add.vue`
        )
}, {
  path: '/music',
  meta: {
    breadcrumb: false,
    title: 'Music Tracks',
    navLink: 'Music',
    roles: ['admin']
  },
  name: 'Music',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Music/list.vue`
        )
}, {
  path: '/music/add',
  meta: {
    breadcrumb: false,
    title: 'Music',
    navLink: 'Music',
    roles: ['admin']
  },
  name: 'AddMusic',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Music/add.vue`
        )
},
{
  path: '/edit/nickname',
  meta: {
    breadcrumb: false,
    title: 'Requests / Display Name',
    navLink: 'DisplayNameChange',
    roles: ['admin']
  },
  name: 'DisplayNameChange',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/EditRequests/displayName.vue`
        )
},
{
  path: '/requests/enableMenu',
  meta: {
    breadcrumb: false,
    title: 'Requests / Enable Menu',
    navLink: 'EnableMenuRequests',
    roles: ['agency', 'caseworker']
  },
  name: 'EnableMenuRequests',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/EditRequests/enableMenu.vue`
        )
},
{
  path: '/requests/familyContent',
  meta: {
    breadcrumb: false,
    title: 'Requests / Family Content',
    navLink: 'FamilyContentRequests',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'FamilyContentRequests',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/EditRequests/familyContent.vue`
        )
},
// {
//   path: '/requests/blogs',
//   meta: {
//     breadcrumb: false,
//     title: 'Requests / Blogs',
//     navLink: 'BlogRequests',
//     roles: ['admin']
//   },
//   name: 'BlogRequests',
//   component: () =>
//         import(
//           /* webpackChunkName: "routes" */
//           /* webpackMode: "lazy-once" */
//           `@/pages/EditRequests/blogs.vue`
//         )
// },
{
  path: '/FileCategoryAdd',
  meta: {
    breadcrumb: false,
    title: 'Add File Categories',
    navLink: 'Add File Categories',
    roles: ['admin']
  },
  name: 'FileCategoriesAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/FileCategoryAdd.vue`
        )
}, {
  path: '/address',
  meta: {
    breadcrumb: false,
    title: 'Address',
    navLink: 'Configuration',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'AddEditAddress',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Address.vue`
        )
}, 
{
  path: '/flipbook',
  meta: {
    breadcrumb: false,
    title: 'Flipbook',
    navLink: 'Dashboard',
    roles: ['parent', 'child']
  },
  name: 'Flipbook',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Flipbook.vue`
        )
}, 
{
  path: '/states',
  meta: {
    breadcrumb: false,
    title: 'States',
    navLink: 'States',
    roles: ['admin']
  },
  name: 'States',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/States/list.vue`
        )
}, {
  path: '/countries',
  meta: {
    breadcrumb: false,
    title: 'Countries',
    navLink: 'Countries',
    roles: ['admin']
  },
  name: 'Countries',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Country/list.vue`
        )
}, {
  path: '/states/add',
  meta: {
    breadcrumb: false,
    title: 'States',
    navLink: 'States',
    roles: ['admin']
  },
  name: 'addState',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/States/add.vue`
        )
}, {
  path: '/countries/add',
  meta: {
    breadcrumb: false,
    title: 'Countries',
    navLink: 'Countries',
    roles: ['admin']
  },
  name: 'addCountry',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Country/add.vue`
        )
}, {
  path: '/pdfTemplate',
  meta: {
    breadcrumb: false,
    title: 'PDF Templates',
    navLink: 'Dashboard',
    roles: ['parent', 'child']
  },
  name: 'pdfTemplate',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/PDFTemplate.vue`
        )
}, {
  path: '/pdfTemplate/add',
  meta: {
    breadcrumb: false,
    title: 'PDF Templates',
    navLink: 'Dashboard',
    roles: ['parent', 'child']
  },
  name: 'pdfTemplateAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/PDFTemplateAdd.vue`
        )
}, {
  path: '/timeline/add',
  meta: {
    breadcrumb: false,
    title: 'Timeline',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'addTimeline',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Timelines/add.vue`
        )
}, {
  path: '/admin/timeline/add',
  meta: {
    breadcrumb: false,
    title: 'Timeline',
    navLink: 'AdminTimelines',
    roles: ['admin']
  },
  name: 'AdminAddTimeline',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Timelines/admin_add.vue`
        )
}, {
  path: '/timelines',
  meta: {
    breadcrumb: false,
    title: 'Timeline',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'timelines',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Timelines/list.vue`
        )
}, {
  path: '/admin/timelines',
  meta: {
    breadcrumb: false,
    title: 'Timeline',
    navLink: 'AdminTimelines',
    roles: ['admin']
  },
  name: 'AdminTimelines',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Timelines/admin_list.vue`
        )
}, {
  path: '/messages',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'Messages',
    roles: ['parent', 'agency', 'caseworker']
  },
  name: 'Messages',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/list.vue`
        )
}, {
  path: '/admin/messages',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'AdminMessages',
    roles: ['admin']
  },
  name: 'AdminMessages',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/admin_list.vue`
        )
}, {
  path: '/admin/messageGroup',
  meta: {
    breadcrumb: false,
    title: 'Message Group',
    navLink: 'MessageGroups',
    roles: ['admin']
  },
  name: 'MessageGroups',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/group_list.vue`
        )
}, {
  path: '/admin/messageGroup/add',
  meta: {
    breadcrumb: false,
    title: 'Message Group',
    navLink: 'MessageGroups',
    roles: ['admin']
  },
  name: 'MessageGroupsAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/group_add.vue`
        )
}, {
  path: '/message/add',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'Messages',
    roles: ['parent', 'agency', 'caseworker']
  },
  name: 'addMessage',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/add.vue`
        )
}, {
  path: '/message/adminParentAdd',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'Messages',
    roles: ['parent']
  },
  name: 'adminParentMessageAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/admin_parent.vue`
        )
}, {
  path: '/message/reply/:conversationId',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'Messages',
    roles: ['parent', 'agency', 'caseworker']
  },
  name: 'replyMessage',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/reply.vue`
        )
}, {
  path: '/admin/message/add',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'AdminMessages',
    roles: ['admin']
  },
  name: 'adminAddMessage',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/admin_add.vue`
        )
}, {
  path: '/admin/message/reply/:conversationId',
  meta: {
    breadcrumb: false,
    title: 'Messages',
    navLink: 'AdminMessages',
    roles: ['admin']
  },
  name: 'adminReplyMessage',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Messages/admin_reply.vue`
        )
}, {
  path: '/tasks',
  meta: {
    breadcrumb: false,
    title: 'Tasks',
    navLink: 'Tasks',
    roles: ['admin']
  },
  name: 'Tasks',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Tasks/list.vue`
        )
}, {
  path: '/projectList',
  meta: {
    breadcrumb: false,
    title: 'Projects',
    navLink: 'allProjects',
    roles: ['admin']
  },
  name: 'allProjects',
  component: () =>
          import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/VideoProject/allProjects.vue`
          )
}, {
  path: '/tasks/add',
  meta: {
    breadcrumb: false,
    title: 'Tasks',
    navLink: 'Tasks',
    roles: ['admin']
  },
  name: 'taskAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Tasks/add.vue`
        )
}, {
  path: '/admin/families/:profileStatus?',
  meta: {
    breadcrumb: false,
    title: 'Clients',
    navLink: 'ClientList',
    roles: ['admin']
  },
  name: 'ClientList',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Families/list.vue`
        )
}, {
  path: '/family/add',
  meta: {
    breadcrumb: false,
    title: 'Clients',
    navLink: 'ClientList',
    roles: ['admin']
  },
  name: 'ClientAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Families/add.vue`
        )
}, {
  path: '/admin/feedbacks',
  meta: {
    breadcrumb: false,
    title: 'Feedbacks',
    navLink: 'Feedbacks',
    roles: ['admin']
  },
  name: 'Feedbacks',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Feedbacks/list.vue`
        )
}, {
  path: '/admin/feedbacks/add',
  meta: {
    breadcrumb: false,
    title: 'Feedbacks',
    navLink: 'Feedbacks',
    roles: ['admin']
  },
  name: 'feedbacks',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Feedbacks/add.vue`
        )
}, {
  path: '/admin/faq',
  meta: {
    breadcrumb: false,
    title: 'FAQ',
    navLink: 'AdminFAQ',
    roles: ['admin']
  },
  name: 'AdminFAQ',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/FAQ/admin_list.vue`
        )
}, {
  path: '/admin/emailTemplate',
  meta: {
    breadcrumb: false,
    title: 'Email Template',
    navLink: 'EmailTemplate',
    roles: ['admin']
  },
  name: 'EmailTemplate',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/EmailTemplate/list.vue`
        )
},
{
  path: '/admin/websiteTemplate',
  meta: {
    breadcrumb: false,
    title: 'Website Template',
    navLink: 'WebsiteTemplate',
    roles: ['admin']
  },
  name: 'WebsiteTemplate',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/WebsiteTemplate/list.vue`
        )
},
{
  path: '/admin/websiteTemplate/add',
  meta: {
    breadcrumb: false,
    title: 'Website Template',
    navLink: 'WebsiteTemplate',
    roles: ['admin']
  },
  name: 'AddWebsiteTemplate',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/WebsiteTemplate/add.vue`
        )
},
{
  path: '/websiteTemplates',
  meta: {
    breadcrumb: false,
    title: 'Website',
    navLink: 'Dashboard',
    roles: ['parent']
  },
  name: 'ListWebsiteTemplate',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/WebsiteTemplate/list_parent.vue`
        )
},
{
  path: '/admin/domains',
  meta: {
    breadcrumb: false,
    title: 'Client Domains',
    navLink: 'ClientDomains',
    roles: ['admin']
  },
  name: 'ClientDomains',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ClientDomains/list.vue`
        )
},
{
  path: '/bmcampaigns',
  meta: {
    breadcrumb: false,
    title: 'Campaigns',
    navLink: 'BMCampaignList',
    roles: ['admin']
  },
  name: 'BMCampaignList',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Campaign/admin_main.vue`
        )
},
{
  path: '/campaigns/agency',
  meta: {
    breadcrumb: false,
    title: 'Individual Campaigns',
    navLink: 'BMCampaignsIndividual',
    roles: ['agency', 'caseworker']
  },
  name: 'BMCampaignsIndividual',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Campaign/agency_main.vue`
        )
},
{
  path: '/campaigns/group',
  meta: {
    breadcrumb: false,
    title: 'Group Campaign',
    navLink: 'BMCampaignsGroup',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'BMCampaignsGroup',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Campaign/group_campaigns.vue`
        )
},
{
  path: '/campaigns/group/requests',
  meta: {
    breadcrumb: false,
    title: 'Group Requests',
    navLink: 'BMCampaignsGroupRequests',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'BMCampaignsGroupRequests',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Campaign/group_requests.vue`
        )
},
{
  path: '/bmcampaigns/config',
  meta: {
    breadcrumb: false,
    title: 'Campaign Configuration',
    navLink: 'BMCampaignConfig',
    roles: ['admin']
  },
  name: 'BMCampaignConfig',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Campaign/admin_settings.vue`
        )
},
{
  path: '/admin/domains/add',
  meta: {
    breadcrumb: false,
    title: 'Client Domains',
    navLink: 'ClientDomains',
    roles: ['admin']
  },
  name: 'AddClientDomains',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/ClientDomains/add.vue`
        )
}, {
  path: '/admin/surveys',
  meta: {
    breadcrumb: false,
    title: 'Surveys',
    navLink: 'Surveys',
    roles: ['admin']
  },
  name: 'Surveys',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Surveys/list.vue`
        )
}, {
  path: '/reports',
  meta: {
    breadcrumb: false,
    title: 'Reports',
    navLink: 'Reports',
    roles: ['admin']
  },
  name: 'Reports',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Reports/Reports.vue`
        )
}, {
  path: '/admin/invoiceReports',
  meta: {
    breadcrumb: false,
    title: 'Billing Reports',
    navLink: 'InvoiceReports',
    roles: ['admin']
  },
  name: 'InvoiceReports',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Reports/BillingReports.vue`
        )
}, {
  path: '/admin/invoices',
  meta: {
    breadcrumb: false,
    title: 'Invoices',
    navLink: 'Invoices',
    roles: ['admin']
  },
  name: 'Invoices',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Invoices/list.vue`
        )
},
{
  path: '/payment/transactions',
  meta: {
    breadcrumb: false,
    title: 'Payment Transactions',
    navLink: 'PaymentTransactions',
    roles: ['admin', 'agency', 'caseworker']
  },
  name: 'PaymentTransactions',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Reports/AuthorizeNetTransactionReport.vue`
        )
},
{
  path: '/parent/payment/transactions',
  meta: {
    breadcrumb: false,
    title: 'Payment Transactions',
    navLink: 'ParentPaymentTransactions',
    roles: ['parent']
  },
  name: 'ParentPaymentTransactions',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Reports/AuthorizeNetTransactionsParent.vue`
        )
},
{
  path: '/surveys/add',
  meta: {
    breadcrumb: false,
    title: 'Surveys',
    navLink: 'Surveys',
    roles: ['admin', 'parent']
  },
  name: 'SurveysAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Surveys/add.vue`
        )
}, {
  path: '/faq',
  meta: {
    breadcrumb: false,
    title: 'FAQ',
    navLink: 'FAQ',
    roles: ['agency', 'parent', 'caseworker']
  },
  name: 'FAQ',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/FAQ/list.vue`
        )
}, {
  path: '/admin/faq/add',
  meta: {
    breadcrumb: false,
    title: 'FAQ',
    navLink: 'AdminFAQ',
    roles: ['admin']
  },
  name: 'AddFAQ',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/FAQ/add.vue`
        )
}, {
  path: '/admin/agencies',
  meta: {
    breadcrumb: false,
    title: 'Agencies',
    navLink: 'Agencies',
    roles: ['admin']
  },
  name: 'Agencies',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Agencies/list.vue`
        )
},
{
  path: '/admin/agencies/add',
  meta: {
    breadcrumb: false,
    title: 'AdminAgencyAdd',
    navLink: 'Agencies',
    roles: ['admin']
  },
  name: 'AdminAgencyAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Agencies/add.vue`
        )
},
{
  path: '/views',
  meta: {
    breadcrumb: false,
    title: 'Activity',
    navLink: 'Activity',
    roles: ['parent']
  },
  name: 'Activity',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Activity/list.vue`
        )
}, {
  path: '/agency/views',
  meta: {
    breadcrumb: false,
    title: 'Activity',
    navLink: 'AgencyActivity',
    roles: ['agency', 'caseworker']
  },
  name: 'AgencyActivity',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Activity/agency_list.vue`
        )
}, {
  path: '/agency/account',
  meta: {
    breadcrumb: false,
    title: 'Accounts',
    navLink: 'Accounts',
    roles: ['agency', 'caseworker']
  },
  name: 'Accounts',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Agencies/CaseWorker/case-worker.vue`
        )
}, {
  path: '/agency/account/add',
  meta: {
    breadcrumb: false,
    title: 'Accounts',
    navLink: 'Accounts',
    roles: ['agency', 'caseworker']
  },
  name: 'CaseWorkerAdd',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Agencies/CaseWorker/addCaseworker.vue`
        )
}, {
  path: '/agency/account/:id',
  meta: {
    breadcrumb: false,
    title: 'Accounts',
    navLink: 'Accounts',
    roles: ['agency', 'caseworker']
  },
  name: 'AccountEdit',
  component: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/pages/Agencies/CaseWorker/editCaseWorker.vue`
        )
}

];



// WEBPACK FOOTER //
// ./src/router/paths.js